import React from 'react';
import './comparisonPanel.css';
import { useSelector } from 'react-redux';

// Imports de Tecnología
import ComparisonContainerTechnologyByField from '../client-comparison/ComparisonContainerTechnologyByField';
import ComparisonContainerTechnologyByMatrix from '../client-comparison/ComparisonContainerTechnologyByMatrix';

// Imports de Alternativas (Asegúrate de que las rutas sean correctas)
import ComparisonContainerAlternativeByField from '../client-comparison/ComparisonContainerAlternativeByField';
import ComparisonContainerAlternativeByMatrix from '../client-comparison/ComparisonContainerAlternativeByMatrix';

// Imports de Experience (Asegúrate de que las rutas sean correctas)
import ComparisonContainerExperienceByField from '../client-comparison/ComparisonContainerExperienceByField';
import ComparisonContainerExperienceByMatrix from '../client-comparison/ComparisonContainerExperienceByMatrix';

// Imports de Innovation (Asegúrate de que las rutas sean correctas)
import ComparisonContainerInnovationByField from '../client-comparison/ComparisonContainerInnovationByField';
import ComparisonContainerInnovationByMatrix from '../client-comparison/ComparisonContainerInnovationByMatrix';

// Imports de Assistance (Asegúrate de que las rutas sean correctas)
import ComparisonContainerAssistanceByField from '../client-comparison/ComparisonContainerAssistanceByField';
import ComparisonContainerAssistanceByMatrix from '../client-comparison/ComparisonContainerAssistanceByMatrix';

// Imports de Financial (Asegúrate de que las rutas sean correctas)
import ComparisonContainerFinancialByField from '../client-comparison/ComparisonContainerFinancialByField';
import ComparisonContainerFinancialByMatrix from '../client-comparison/ComparisonContainerFinancialByMatrix';
import { useTranslation } from 'react-i18next';


const ComparisonPanel = ({
    isOpen,
    onClose,
    comparisonMode,
    moduleSelected
}) => {
    const { t } = useTranslation();

    // 1. Obtenemos todos los estados de Redux
    const technology = useSelector((state) => state.technology);
    const alternative = useSelector((state) => state.alternative);
    const experience = useSelector((state) => state.experience);
    const innovation = useSelector((state) => state.innovation);
    const assistance = useSelector((state) => state.assistance);
    const financial = useSelector((state) => state.financial);

    // 2. Mapeo de estados por módulo para acceder dinámicamente
    const moduleStates = {
        technology: { count: technology.numberTechnologySelected, more: technology.moreThanOneIsSelected },
        alternative: { count: alternative.numberAlternativeSelected, more: alternative.moreThanOneIsSelected },
        experience: { count: experience.numberExperienceSelected, more: experience.moreThanOneIsSelected },
        innovation: { count: innovation.numberInnovationSelected, more: innovation.moreThanOneIsSelected },
        assistance: { count: assistance.numberAssistanceSelected, more: assistance.moreThanOneIsSelected },
        financial: { count: financial.numberFinancialSelected, more: financial.moreThanOneIsSelected },
    };

    // Extraemos los valores del módulo actual de forma segura
    const currentModuleKey = moduleSelected?.key;
    const currentCount = moduleStates[currentModuleKey]?.count || 0;

    // 3. Mapeo de componentes (se mantiene igual)
    const componentsMap = {
        technology: { field: ComparisonContainerTechnologyByField, matrix: ComparisonContainerTechnologyByMatrix },
        alternative: { field: ComparisonContainerAlternativeByField, matrix: ComparisonContainerAlternativeByMatrix },
        experience: { field: ComparisonContainerExperienceByField, matrix: ComparisonContainerExperienceByMatrix },
        innovation: { field: ComparisonContainerInnovationByField, matrix: ComparisonContainerInnovationByMatrix },
        assistance: { field: ComparisonContainerAssistanceByField, matrix: ComparisonContainerAssistanceByMatrix },
        financial: { field: ComparisonContainerFinancialByField, matrix: ComparisonContainerFinancialByMatrix }
    };

    const SelectedComponent = componentsMap[currentModuleKey]?.[comparisonMode];

    // 4. Ancho dinámico basado en el 'currentCount' del módulo activo
    const getPanelWidth = () => {
        if (!isOpen) return '0px';
        if (comparisonMode === 'field') return '50vw';
        
        const matrixWidths = { 2: '55vw', 3: '65vw', 4: '75vw', 5: '75vw', 6: '85vw', 7: '85vw', 8: '95vw', 9: '95vw' };
        // Usamos currentCount en lugar de numberTechnologySelected
        return matrixWidths[currentCount] || (currentCount > 9 ? '95vw' : '50vw');
    };

    return (
        <>
            {isOpen && <div className="panel-overlay" onClick={onClose}></div>}

            <div className="comparison-panel" style={{ width: getPanelWidth() }}>
                <div className="panel-header">
                    <h5>Comparación - {`${t(`general.component-search-${moduleSelected.key}`)}` || `${t(`general.component-search-${currentModuleKey}`)}` }</h5>
                    <p className="subtitle">
                        {comparisonMode === 'matrix' ? 'Por Matriz' : 'Por Campo'}
                    </p>
                    <button onClick={onClose} className="close-btn">×</button>
                </div>

                <div className="panel-content">
                    <div className="info-bar">
                        Mostrando <strong>{currentCount}</strong> registros seleccionados por comparar.
                    </div>
                    
                    {SelectedComponent ? (
                        <SelectedComponent />
                    ) : (
                        <div className="error-msg">Módulo "{currentModuleKey}" no soportado o modo no definido.</div>
                    )}
                </div>
            </div>
        </>
    );
};

export default ComparisonPanel;
